import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';

export const useMaintenanceCheck = () => {
  const [showMaintenance, setShowMaintenance] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkMaintenance = async () => {
      try {
        // Check if maintenance mode is enabled
        const { data: settings } = await supabase
          .from('maintenance_settings')
          .select('enabled')
          .single();

        if (!settings?.enabled) {
          setShowMaintenance(false);
          setLoading(false);
          return;
        }

        // Check if user is authenticated
        const { data: { session } } = await supabase.auth.getSession();
        
        if (session?.user) {
          // Check if user has site_admin role
          const { data: roleData } = await supabase
            .from('user_roles')
            .select('role')
            .eq('user_id', session.user.id)
            .eq('role', 'site_admin')
            .maybeSingle();

          // Site admins bypass maintenance
          if (roleData) {
            setShowMaintenance(false);
          } else {
            setShowMaintenance(true);
          }
        } else {
          // Not authenticated, show maintenance
          setShowMaintenance(true);
        }
      } catch (error) {
        console.error('Error checking maintenance:', error);
        // On error, show maintenance to be safe
        setShowMaintenance(true);
      } finally {
        setLoading(false);
      }
    };

    checkMaintenance();

    // Listen for auth state changes
    const { data: { subscription } } = supabase.auth.onAuthStateChange(() => {
      checkMaintenance();
    });

    return () => subscription.unsubscribe();
  }, []);

  return { showMaintenance, loading };
};
